// extracted by css-extract-rspack-plugin
export default {"ClickBehaviorDescription":"CLyEv","isActive":"t8r3z","ClickIcon":"D56K5","Button":"jsfrt"};